<template>
  <div class="">
    <!-- <div class="loading" v-if="loading"></div> -->
    <multiselect
      v-model="selectedOption"
      :options="listData" 
      class="floating"
      style="line-height: 16px; max-width: 100%"
      :style="{ width: width !== '' ? width : '100%' }"
      :multiple="false"
      :label="label"
      :options-limit="300"
      :limit="20"
      :max-height="600"
      :loading="loading"
      :searchable="true"
      :internal-search="false"
      :clear-on-select="false"
      :close-on-select="true"
      :track-by="label"
      :show-labels="false"
      :disabled="disabled" 
      :placeholder="placeholder"
      @input="emitInput"
      @open="fetch"
      @search-change="search"
    ><slot/></multiselect>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { mapActions, mapState } from "vuex";
export default {
  components:{
    Multiselect
  },
  props: [
    "value",
    "endpoint",
    "filterName",
    "label",
    'isCustomLabel',
    "placeholder",
    "autoFetch",
    "width", 
    "kecamatanName",
    'customLabelStoreName',
    "kecamatanId",
    "otherFilter",
    "disabled"
  ],
  data() {
    return {
      loading: false,
      listData: [],
      selectedOption: this.value, // Inisialisasi nilai input dari prop 'value'
    };
  },
  computed: {},
  watch: {
    value(nv, ov) {
      if (nv == null) {
        this.selectedOption = null;
      } else {
        this.selectedOption = nv;
      }
    },
  },
  methods: { 
    fetch() { 
      if (this.autoFetch == true) {
        this.listData = []
        let serverParams = {
          page:0,
          perPage:20
        };
        this.loading = true 
        if (this.otherFilter) {
          serverParams = {
            ...serverParams,
            ...this.otherFilter,
          };
        }
        this.$store
          .dispatch(this.endpoint, serverParams)
          .then(async (response) => {
            this.listData = response.data.data;

            this.loading = false;
          })
          .catch(async (error) => {
            this.listData = [];
            console.log("error", error);
            this.loading = await false;
          });
      }
    },
    emitInput() { 
      this.$emit("input", this.selectedOption);
    }, 
    async search(query = "") {
      // if (query.length < 1) {
      //   return false;
      // }
      let debounce;
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        let serverParams = { 
          [this.filterName || "search"]: query,
          page:0,
          perPage:20
        }; 
        if (this.otherFilter) {
          serverParams = {
            ...serverParams,
            ...this.otherFilter,
          };
        }
        this.loading = true;
        this.listData = [];
        this.$store
          .dispatch(this.endpoint, serverParams)
          .then(async (response) => {
            this.listData = response.data.data;

            this.loading = false;
          })
          .catch(async (error) => {
            this.listData = [];
            console.log("error", error);
            this.loading = await false;
          });
      }, 200);
    },
  },
};
</script> 


// WEBPACK FOOTER //
// src/components/multiselectCustom.vue